<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Preguntas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:item.tipo="{ item }">
            {{ getType(item.tipo) }}
          </template>
          <template v-slot:item.opciones="{ item }">
            {{ item.opciones.length }}
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogNew" persistent scrollable max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="formNew.tipo" :items="tipos" label="Tipo" :rules="formRules.tipo" :disabled="loading" required></v-select>
                  </v-col>
                  <template v-if="showOptions">
                    <v-col cols="12">
                      <v-select v-model="categoria" :items="respuestas.map(function(obj) {return obj.categoria})" label="Categoría de respuestas" :rules="formRules.categoria" :disabled="loading" required></v-select>
                    </v-col>
                    <template v-for="(child, i) in getOptions">
                      <v-col cols="12" :key="i">
                        <v-text-field v-model="formNew.opciones[i]" :label="'Opción ' + (i + 1)" :rules="formRules.opcion" :counter="2000" :disabled="loading" required></v-text-field>
                      </v-col>
                    </template>
                  </template>
                  <v-col cols="6">
                    <template v-if="formNew.tipo == 'numero'">
                      <v-text-field
                        v-model="formNew.minimo"
                        :rules="formRules.minimo"
                        label="Mínimo"
                        type="number"
                        :disabled="loading"
                      ></v-text-field>
                    </template>
                  </v-col>
                  <v-col cols="6">
                    <template v-if="formNew.tipo == 'numero'">
                      <v-text-field
                        v-model="formNew.maximo"
                        :rules="formRules.maximo"
                        label="Máximo"
                        type="number"
                        :disabled="loading"
                      ></v-text-field>
                    </template>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <template v-if="showOptions">
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outlined :disabled="!formNew.opciones.length || loading" color="primary" class="mx-2" @click="removeOption()">
                Quitar opción
              </v-btn>
              <v-btn small outlined :disabled="loading" color="primary" class="mx-2" @click="addOption()">
                Agregar opción
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent scrollable max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="formUpdate.tipo" :items="tipos" label="Tipo" :rules="formRules.tipo" :disabled="loading" required></v-select>
                  </v-col>
                  <template v-for="(child, i) in formUpdate.opciones">
                    <v-col cols="12" :key="i">
                      <v-text-field v-model="formUpdate.opciones[i]" :label="'Opción ' + (i + 1)" :rules="formRules.opcion" :counter="2000" :disabled="loading" required></v-text-field>
                    </v-col>
                  </template>
                  <v-col cols="6">
                    <template v-if="formUpdate.tipo == 'numero'">
                      <v-text-field
                        v-model="formUpdate.minimo"
                        :rules="formRules.minimo"
                        label="Mínimo"
                        type="number"
                        :disabled="loading"
                      ></v-text-field>
                    </template>
                  </v-col>
                  <v-col cols="6">
                    <template v-if="formUpdate.tipo == 'numero'">
                      <v-text-field
                        v-model="formUpdate.maximo"
                        :rules="formRules.maximo"
                        label="Máximo"
                        type="number"
                        :disabled="loading"
                      ></v-text-field>
                    </template>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <template v-if="showOptions">
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outlined :disabled="!formUpdate.opciones.length || loading" color="primary" class="mx-2" @click="removeOption()">
                Quitar opción
              </v-btn>
              <v-btn small outlined :disabled="loading" color="primary" class="mx-2" @click="addOption()">
                Agregar opción
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from '@/utils/services'

export default {
  name: 'preguntas',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [
      { text: 'Idexterno', align: 'center', sortable: false, value: 'idexterno' },
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Tipo', align: 'center', sortable: false, value: 'tipo' },
      { text: 'No. opciones', align: 'center', sortable: false, value: 'opciones' },
      { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
    ],
    items: [],
    tipos: [
      { text: 'Selección múltiple', value: 'seleccion_multiple' },
      { text: 'Opción múltiple', value: 'opcion_multiple' },
      { text: 'Texto corto', value: 'texto_corto' },
      { text: 'Texto largo', value: 'texto_largo' },
      { text: 'Número', value: 'numero' },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Foto', value: 'foto' },
      { text: 'Coordenadas', value: 'coordenadas' },
      { text: 'Comentarios', value: 'comentarios' },
      { text: 'Sección', value: 'seccion' },
      { text: 'Firma', value: 'firma' },
    ],
    respuestas: [],
    categoria: '',
    selected: [],
    dialogNew: false,
    dialogUpdate: false,
    dialogRemove: false,
    formNew: {
      idexterno: '',
      nombre: '',
      tipo: '',
      opciones: [],
      minimo: null,
      maximo: null
    },
    formUpdate: {
      id: '',
      idexterno: '',
      nombre: '',
      tipo: '',
      opciones: [],
      minimo: null,
      maximo: null
    },
    formRules: {
      idexterno: [
        v => !!v || 'El idexterno es obligatorio',
        v => (v && v.length <= 50) || 'El idexterno excede la longitud máxima'
      ],
      nombre: [
        v => !!v || 'El nombre es obligatorio',
        v => (v && v.length <= 150) || 'El nombre excede la longitud máxima'
      ],
      tipo: [
        v => !!v || 'El tipo es obligatorio'
      ],
      categoria: [
        v => !!v || 'La categoría es obligatoria'
      ],
      opcion: [
        v => !!v || 'La opción es obligatoria',
        v => (v && v.length <= 2000) || 'La opción excede la longitud máxima'
      ],
      minimo: [],
      maximo: []
    },
  }),
  mounted() {
    this.refresh()
  },
  computed: {
    showOptions() {
      if (this.dialogNew) {
        if (this.formNew.tipo === 'opcion_multiple' || this.formNew.tipo === 'seleccion_multiple') {
          return true
        }
        else {
          this.formNew.opciones = []
          return false
        }
      }
      else {
        if (this.formUpdate.tipo === 'opcion_multiple' || this.formUpdate.tipo === 'seleccion_multiple') {
          return true
        }
        else {
          this.formUpdate.opciones = []
          return false
        }
      }
    },
    getOptions() {
      let opciones = []
      for (var i = 0; i < this.respuestas.length; i++) {
        if (this.respuestas[i].categoria === this.categoria) {
          opciones = this.respuestas[i].opciones
        }
      }
      this.formNew.opciones = opciones
      return opciones
    }
  },
  methods: {
    refresh() {
      this.loading = true
      services.ws('get', 'preguntas')
        .then(res => {
          if (res.ok) {
            this.items = res.data.preguntas
            this.respuestas = res.data.respuestas
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      for (let key in this.formNew) {
        if (!Array.isArray(this.formNew[key])) {
          this.formNew[key] = ''
        }
        else {
          this.formNew[key] = []
        }
      }
      for (let key in this.formUpdate) {
        if (!Array.isArray(this.formUpdate[key])) {
          this.formUpdate[key] = ''
        }
        else {
          this.formUpdate[key] = []
        }
      }
    },
    cancel() {
      this.clear()
      this.categoria = ''
      this.selected = []
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogRemove = false
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevaPregunta', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarPregunta', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarPregunta', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    removeOption() {
      if (this.dialogNew) {
        if (this.formNew.opciones.length) {
          this.formNew.opciones.splice(-1, 1)
        }
      }
      else {
        if (this.formUpdate.opciones.length) {
          this.formUpdate.opciones.splice(-1, 1)
        }
      }
    },
    addOption() {
      if (this.dialogNew) {
        this.formNew.opciones.push('')
      }
      else {
        this.formUpdate.opciones.push('')
      }
    },
    getType(val) {
      for (let i = 0; i < this.tipos.length; i++) {
        if (this.tipos[i].value == val) {
          return this.tipos[i].text
        }
      }
      return null
    }
  }
}
</script>
